<div class="uk-container uk-container-expand">
  <div class="uk-grid">
    <div class="uk-width-1-1 uk-margin-small-bottom">
      <h2 class="titre-dashboard">Mon Tableau de Bord</h2>
    </div>
  </div>

  <div class="uk-grid" *ngIf="infoDashboard">
    <div class="uk-width-2-3">
      <div class="dashboard-shortcuts" *ngIf="!loading">
        <div class="uk-grid uk-child-width-auto">
          <div *ngFor="let sButton of infoDashboard.shortcuts">
          <ags-shortcut-button 
            [hidden]="!sButton.affichage" class="uk-child-width-1-3@xl padding-card" 
            [title]="sButton.title"
            [icon]="sButton.icon"
            [nbNotif]="sButton.nbNotif"
            [routerLink]="sButton.routerLink"
          >
          </ags-shortcut-button>
          </div>
        </div>
      </div>

      <div class="titre-activite">
        <span>MON ACTIVITÉ</span>
        <hr/>
      </div>
      <div class="dashboard-cards">
        <div class="uk-grid uk-child-width-auto">
          <div *ngFor="let aCard of infoDashboard.cards">
          <ags-activity-card class=" uk-child-width-1-3@xl padding-card"
            [hidden]="!aCard.affichage"
            [number]="aCard.number"
            [title]="aCard.title"
            [text]="aCard.text"
            [textButton]="aCard.textButton"
          >
          </ags-activity-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
